function createRoute(path, name, tab, pageTitle, breadcrumbText) {
    return {
        path,
        name,
        // Component for all tabs
        component: () =>
            import(
                /* webpackChunkName: "[request]" */
                `@/views/commons/discounts/components/DiscountComponent.vue`
            ),
        meta: {
            section: 21,
            module: 7,
            tab,
            pageTitle,
            breadcrumb: [
                {
                    text: breadcrumbText,
                    active: true,
                },
            ],
        },
    };
}

export default [
    {
        path: "discounts",
        name: "workshop-discounts",
        redirect: { name: "workshop-discounts-pending" },
        // Main component for all tabs
        component: () => import("@/views/commons/discounts/Discounts.vue"),
        meta: {
            section: 21,
            module: 7,
            breadcrumb: [
                {
                    text: "discounts",
                },
            ],
            tabs: [
                {
                    title: "Pending",
                    name: "workshop-discounts-pending",
                },
                {
                    title: "Approved",
                    name: "workshop-discounts-approved",
                },
                {
                    title: "Discounted",
                    name: "workshop-discounts-discounted",
                },
                {
                    title: "Anulled",
                    name: "workshop-discounts-anulled",
                },
            ],
        },
        children: [
            createRoute(
                "pending",
                "workshop-discounts-pending",
                "pending",
                "Discounts",
                "Pending"
            ),
            createRoute(
                "approved",
                "workshop-discounts-approved",
                "approved",
                "Discounts",
                "Approved"
            ),
            createRoute(
                "discounted",
                "workshop-discounts-discounted",
                "discounted",
                "Discounts",
                "Discounted"
            ),
            createRoute(
                "anulled",
                "workshop-discounts-anulled",
                "anulled",
                "Discounts",
                "Anulled"
            ),
        ],
    },
];
